@if (verification$ | async; as verification) {
  <div>
    @if (verification.isNotYetVerified) {
      <div class="banner_card card">
        @if (verification.isVerificationPending) {
          <div class="banner_card-icon">
            <svg-inline [src]="'/assets/images/new-verify_pending-icon.svg'" [alt]="'verify_alt_text' | translate" />
          </div>
          <div class="banner_card-header">{{ "dashboard_banner_verification_started_title" | translate }}</div>
          <div class="banner_card-body">{{ "dashboard_banner_verification_started_subtitle" | translate }}</div>
          <div class="banner_card-close"></div>
        } @else {
          <div class="banner_card-icon">
            <svg-inline [src]="'/assets/images/new-verify_now-icon.svg'" [alt]="'verify_alt_text' | translate" />
          </div>
          <div class="banner_card-header">{{
            "dashboard_verify_now_title" | translate: [verification.firstName]
          }}</div>
          <div class="banner_card-body">{{ "dashboard_verify_now_subtitle" | translate }}</div>
          <div class="banner_card-close">
            <a class="btn btn-primary" (click)="verify()">
              {{ "dashboard_banner_verify_now" | translate }}
            </a>
          </div>
        }
      </div>
    }
  </div>
}
